"use client";

import * as React from "react";
import { ArrowRight, Cpu, MapPin, Zap } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const projects = [{
  id: 1,
  title: "Komerční administrativní komplex",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/project_commercial_office.png",
  location: "Downtown Metro",
  systemType: "VRF Heat Recovery",
  efficiencyRating: "SEER 22.5",
  ratio: 4 / 3
}, {
  id: 2,
  title: "Průmyslový výrobní závod",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/project_industrial_facility.png",
  location: "Northside Industrial Park",
  systemType: "Chilled Water System",
  efficiencyRating: "0.55 kW/ton",
  ratio: 16 / 9
}, {
  id: 3,
  title: "Luxusní rezidenční výšková budova",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/project_residential_highrise.png",
  location: "West End District",
  systemType: "Multi-Zone Heat Pump",
  efficiencyRating: "HSPF 11.0",
  ratio: 3 / 4
}, {
  id: 4,
  title: "Modernizace chlazení datového centra",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/project_data_center.png",
  location: "Tech Corridor",
  systemType: "Precision CRAC Units",
  efficiencyRating: "PUE 1.15",
  ratio: 1 / 1
}, {
  id: 5,
  title: "Rozšíření nemocničního křídla",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/project_hospital_wing.png",
  location: "Medical Center",
  systemType: "100% Outside Air VAV",
  efficiencyRating: "MERV 15 Filtration",
  ratio: 16 / 9
}, {
  id: 6,
  title: "Maloobchodní nákupní centrum",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/project_retail_mall.png",
  location: "Suburban Plaza",
  systemType: "Rooftop Packaged Units",
  efficiencyRating: "SEER 18.0",
  ratio: 4 / 3
}];
export default function SuccessInTheField() {
  return <section id="success-in-the-field" className="dark bg-background text-foreground py-24 px-4 md:px-6 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-10 pointer-events-none" />

      <div className="max-w-screen-xl mx-auto relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 tracking-tight">
            Úspěchy v terénu
          </h2>
          <p className="text-lg text-muted-foreground">
            Ukázka naší inženýrské preciznosti a moderních HVAC řešení v různých prostředích. Najetím na libovolný projekt zobrazíte technické specifikace.
          </p>
        </div>

        {}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {projects.map((project, i) => <div key={project.id} data-index={i} className="break-inside-avoid relative group overflow-hidden rounded-xl shadow-lg bg-card border border-border/50">
              <AspectRatio ratio={project.ratio}>
                <img src={project.image} alt={project.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />
              </AspectRatio>

              {}
              <div className="absolute inset-0 bg-primary/90 backdrop-blur-sm flex flex-col justify-center p-6 -translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
                <h3 className="text-2xl font-bold text-primary-foreground mb-8 leading-tight">
                  {project.title}
                </h3>
                
                <div className="font-mono text-sm text-primary-foreground/90 space-y-4">
                  <div className="flex items-center justify-between border-b border-primary-foreground/20 pb-2">
                    <div className="flex items-center gap-2 text-primary-foreground/70">
                      <MapPin className="w-4 h-4" />
                      <span>LOK</span>
                    </div>
                    <span className="text-right font-semibold">{project.location}</span>
                  </div>
                  
                  <div className="flex items-center justify-between border-b border-primary-foreground/20 pb-2">
                    <div className="flex items-center gap-2 text-primary-foreground/70">
                      <Cpu className="w-4 h-4" />
                      <span>SYS</span>
                    </div>
                    <span className="text-right font-semibold">{project.systemType}</span>
                  </div>
                  
                  <div className="flex items-center justify-between border-b border-primary-foreground/20 pb-2">
                    <div className="flex items-center gap-2 text-primary-foreground/70">
                      <Zap className="w-4 h-4" />
                      <span>EFE</span>
                    </div>
                    <span className="text-right font-semibold">{project.efficiencyRating}</span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="font-semibold tracking-wide">
            <Link to="/ProjectsPage">
              Zobrazit všechny projekty
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}